<template>
  <section>
    <form method="post" @submit.prevent="send" novalidate>
      <div class="modal-card">
        <header class="modal-card-head">
          <p class="modal-card-title is-centered">
            {{ $t('attributes.add') + $t('attributes.page_seo_name') }}
          </p>
        </header>
        <section class="modal-card-body">
          <form-wrapper :validator="$v.form">
            <form-group
              horizontal
              name="name"
              :label="$t('attributes.page_seo_name') + $t('attributes.name')"
            >
              <b-input
                v-model="form.name"
                name="catalog_no"
                maxlength="15"
                :placeholder="
                  $t('message.please_input') +
                    $t('attributes.page_seo_name') +
                    $t('attributes.name')
                "
                expanded
              ></b-input>
            </form-group>

            <form-group
              horizontal
              name="url"
              maxlength="50"
              :label="$t('attributes.page_seo_url')"
            >
              <b-input
                v-model="form.url"
                name="url"
                :placeholder="
                  $t('message.please_input') + $t('attributes.page_seo_url')
                "
                expanded
              ></b-input>
            </form-group>

            <form-group
              horizontal
              name="page_title"
              :label="$t('attributes.page_seo_page_title')"
            >
              <b-input
                v-model="form.page_title"
                type="textarea"
                name="page_title"
                :placeholder="
                  $t('message.please_input') +
                    $t('attributes.page_seo_page_title')
                "
                expanded
              ></b-input>
            </form-group>

            <form-group
              horizontal
              name="meta_title"
              :label="$t('attributes.page_seo_meta_title')"
            >
              <b-input
                v-model="form.meta_title"
                type="textarea"
                name="meta_title"
                :placeholder="
                  $t('message.please_input') +
                    $t('attributes.page_seo_meta_title')
                "
                expanded
              ></b-input>
            </form-group>
            <form-group
              horizontal
              name="meta_keyword"
              :label="$t('attributes.page_seo_meta_keyword')"
            >
              <b-input
                v-model="form.meta_keyword"
                type="textarea"
                name="meta_keyword"
                :placeholder="
                  $t('message.please_input') +
                    $t('attributes.page_seo_meta_keyword')
                "
                expanded
              ></b-input>
            </form-group>
            <form-group
              horizontal
              name="meta_description"
              :label="$t('attributes.page_seo_meta_description')"
            >
              <b-input
                v-model="form.meta_description"
                type="textarea"
                name="meta_description"
                :placeholder="
                  $t('message.please_input') +
                    $t('attributes.page_seo_meta_description')
                "
                expanded
              ></b-input>
            </form-group>
          </form-wrapper>
        </section>

        <footer class="modal-card-foot">
          <b-button :loading="isSending" @click="$parent.close()">
            {{ $t('attributes.cancel') }}
          </b-button>
          <b-button :loading="isSending" type="is-primary" native-type="submit">
            {{ $t('attributes.add') }}
          </b-button>
        </footer>
      </div>
    </form>
  </section>
</template>

<script>
import { maxLength, required } from 'vuelidate/lib/validators'

export default {
  name: 'PageSeoCreateForm',
  props: {
    isSending: {
      type: Boolean,
      default: true
    }
  },
  data() {
    return {
      form: {
        name: '',
        url: '',
        page_title: '',
        meta_title: '',
        meta_keyword: '',
        meta_description: ''
      }
    }
  },
  validations: {
    form: {
      name: { required, maxLength: maxLength(50) },
      url: { required, maxLength: maxLength(50) },
      page_title: { maxLength: maxLength(1500) },
      meta_title: { maxLength: maxLength(1500) },
      meta_keyword: { maxLength: maxLength(1500) },
      meta_description: { maxLength: maxLength(1500) }
    }
  },
  computed: {},
  mounted() {},
  methods: {
    send() {
      this.$v.$touch()

      if (this.$v.$invalid) {
        return
      }

      this.$emit('onSend', this.form)
    }
  }
}
</script>
